import { Injectable } from '@angular/core';

@Injectable()
export class MetaDataService {

	constructor() { }

	setMetaDescription(newString: string): void {
		const metaTag = document.getElementsByTagName('head')[0].querySelector('meta[name="description"]');
		if (!metaTag) {
			const node = document.createElement('meta');
			node.name = 'description';
			node.content = newString;
			document.getElementsByTagName('head')[0].appendChild(node);
		} else {
			metaTag.setAttribute('content', newString);
		}
	}
  
}
